<template>
    <div>
        <div class="citation-container">
            <draggable 
                :options="{handle :'.drag-handle'}"
            >
                <div
                v-for="(citationEntry, citationIndex) in citations" 
                :key="citationIndex"
                style="margin: 10px 0;">
                    <div style="border-bottom: 1px dotted #aaa; padding: 8px; font-size: 85%;">
                        <md-icon class="drag-handle" style="float: left;">
                            drag_handler
                        </md-icon>
                        <editable
                                :content="citationEntry"
                                @update="updateCitation(citationIndex, $event)" 
                                class="div-textarea"
                                @blur="$emit('save')"
                        >
                        </editable>
                    </div>
                </div>
            </draggable>
            <div style="color: red; font-weight: bold" v-if="citations && citations.length == 0 && !notRequired">
                <br>
                Please try to add at least one citation if appropriate!
            </div>
            <md-button class="md-primary md-raised" @click="addCitation()" style="margin-top: 20px">
                Add Citation
            </md-button>

        </div>
    </div>
</template>

<script>
	import draggable from 'vuedraggable'
	import Editable from '../Editable.vue'

    export default {
        components: {
            draggable,
            Editable
        },
        props: {
            notRequired: {
                type: Boolean
            },
            citations: {
                type: Array
            }
        },
        methods: {
            addCitation: function(){
                this.citations.push(" ")
            },
            updateCitation: function(citationIndex, newText){
				if(newText.trim() == ""){
                    document.activeElement.blur();
                    this.citations.splice(citationIndex, 1)
                    this.$emit("save")
				}
				else {
					this.$set(this.citations, citationIndex, newText)
				}
			},
        }
    }
</script>

